import React from 'react';
import { gql, useQuery } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput, DateInput, DateField } from 'react-admin';
import List from 'components/List';
import MarketInput from 'components/MarketInput';
import PositionInput from 'components/PositionInput';
import LinkField from 'components/LinkField';
import RateSettingsBulkUploadActions from '../shared/RateSettingsBulkUploadActions';
import { getSettingsQuery } from '../utils/getSettingsQuery';

const TEMPLATE_URL_QUERY = gql`
  query {
    marketPositionRateSettingTemplateUrl
  }
`;

const MarketPositionRateSettingListFilters = [
  <IdInput />,
  <MarketInput alwaysOn resettable />,
  <PositionInput emptyText="All" alwaysOn />,
  <BooleanInput alwaysOn source="active" />,
  <DateInput alwaysOn label="Last review after" source="search.last_rate_review_from" />,
];

const MarketPositionRateSettingList = () => {
  const { data: templateUrlData } = useQuery(TEMPLATE_URL_QUERY);
  const downloadUrl = templateUrlData?.marketPositionRateSettingTemplateUrl ?? '';

  return (
    <List
      filters={MarketPositionRateSettingListFilters}
      exporter={false}
      additionalActions={
        <RateSettingsBulkUploadActions
          accessResource="MarketPositionRateSetting"
          downloadUrl={downloadUrl}
          uploadUrl="v3/admin/market_position_rate_settings/import"
        />
      }
    >
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="Market" source="market.display_name" sortBy="market_name" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />
        <BooleanField source="active" />
        <DateField source="last_rate_review" />
      </Datagrid>
    </List>
  );
};

MarketPositionRateSettingList.query = gql`
  query marketPositionRateSettings($input: MarketPositionRateSettingQueryInput) {
    _marketPositionRateSettingsMeta(input: $input) {
      count
    }
    marketPositionRateSettings(input: $input) {
      id
      active
      last_rate_review
      market {
        id
        display_name
      }
      position {
        id
        display_name
      }
      specialty {
        id
        label
      }
      market_id
      position_id
      specialty_id
      market_position_rate_setting_id
      market_position_rate_setting_active
      state_position_rate_setting_id
      state_position_rate_setting_active
      updated_at
      ${getSettingsQuery(false, 'settings', true)}
    }
  }
`;

export default MarketPositionRateSettingList;
